<div class="filter-fields">
  <div class="filter-row">
    <!-- Modo Default: Campo de busca por nome -->
    <div class="search-field" *ngIf="filterMode === 'default'">
      <input type="text" [(ngModel)]="searchText" (input)="onSearchChange()" placeholder="Procure o nome aqui"
        class="search-input">
      <img src="assets/icons/search.png" alt="Lupa" class="search-icon">
    </div>

    <!-- Modo Admin: Select -->
    <div class="search-field" *ngIf="filterMode === 'admin'">
      <select [(ngModel)]="adminSearchValue" (change)="onAdminSearchChange()" class="search-input admin-select">
        <option value="">Selecione o Tipo de Campanha</option>
        <option *ngFor="let option of adminFilterOptions" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>

    <!-- Filtros -->
    <div class="filters-container">
      <!-- Ordenação alfabética (apenas modo default) -->
      <div class="filter-item" *ngIf="filterMode === 'default'">
        <div *ngIf="alphabeticalOrder" class="filter-chip">
          <span class="chip-text">{{ alphabeticalOrder }}</span>
          <button class="chip-close" (click)="removeAlphabeticalOrder()">
            <span>×</span>
          </button>
        </div>
      </div>

      <!-- Filtro Renewal/Pré-Aprovado (apenas modo default) -->
      <div class="filter-item filter-item--selection" *ngIf="filterMode === 'default'">
        <div class="selected-filters" *ngIf="selectedFilters.length > 0 || selectedStatusLeadIdFilters.length > 0">
          <div *ngFor="let filter of selectedFilters" class="filter-chip">
            <span class="chip-text">{{ filter }}</span>
            <button class="chip-close" (click)="removeFilter(filter)">
              <span>×</span>
            </button>
          </div>
          <div *ngFor="let statusLeadId of selectedStatusLeadIdFilters" class="filter-chip">
            <span class="chip-text">{{ getSelectedStatusLeadNomeFilterById(statusLeadId) }}</span>
            <button class="chip-close" (click)="removeStatusLeadIdFilter(statusLeadId)">
              <span>×</span>
            </button>
          </div>
        </div>

        @if(hasFilterTrigger){
        <div class="filter-trigger">
          <!-- BOTÃO DE FILTRO COM CONTADOR MODIFICADO -->
          <button class="filter-button" (click)="toggleFilterPopup()" [class.active]="getTotalFilterCount() > 0"
            [attr.data-filter-count]="getTotalFilterCount()">
            <img src="assets/icons/filter.png" alt="Filtro" class="filter-icon">
          </button>

          <!-- Modal do filtro - Desktop -->
          <div *ngIf="showFilterPopup && !isMobile()" class="filter-modal">
            <h2 class="filter-modal-title">Filtrar</h2>

            <!-- Seção Pré Aprovação -->
            <div class="filter-section" *ngIf="isAvailableFilter('preAprovado')">
              <label class="filter-section-label">Pré Aprovação:</label>
              <div class="filter-buttons-group">
                <button class="filter-pill-button"
                  [class.selected]="isPreAprovacaoSelected('Pré Aprovação: Pré Aprovado')"
                  (click)="togglePreAprovacao('Pré Aprovação: Pré Aprovado')">
                  Pré Aprovado
                </button>
                <button class="filter-pill-button"
                  [class.selected]="isPreAprovacaoSelected('Pré Aprovação: Necessita Análise')"
                  (click)="togglePreAprovacao('Pré Aprovação: Necessita Análise')">
                  Necessita Análise
                </button>
                <button class="filter-pill-button"
                  [class.selected]="isPreAprovacaoSelected('Pré Aprovação: Não Solicitado')"
                  (click)="togglePreAprovacao('Pré Aprovação: Não Solicitado')">
                  Não Solicitado
                </button>
              </div>
            </div>

            <!-- Seção Renova+ -->
            <div class="filter-section" *ngIf="isAvailableFilter('renovaMais')">
              <label class="filter-section-label">Renova+:</label>
              <div class="filter-buttons-group">
                <button class="filter-pill-button" [class.selected]="isRenovaSelected('Renova+: Sim')"
                  (click)="toggleRenova('Renova+: Sim')">
                  Sim
                </button>
                <button class="filter-pill-button" [class.selected]="isRenovaSelected('Renova+: Não')"
                  (click)="toggleRenova('Renova+: Não')">
                  Não
                </button>
              </div>
            </div>

            <!-- Seção Origem -->
            <div class="filter-section" *ngIf="isAvailableFilter('origem')">
              <label class="filter-section-label">Origem:</label>
              <div class="filter-buttons-group">
                @if (availableOrigins.includes('sempre-novo')) {
                <button class="filter-pill-button" [class.selected]="isOrigemSelected('Origem: Sempre Novo')"
                  (click)="toggleOrigem('Origem: Sempre Novo')">
                  Sempre Novo
                </button>
                }

                @if (availableOrigins.includes('ofertas-vw')) {
                <button class="filter-pill-button" [class.selected]="isOrigemSelected('Origem: Ofertas VW')"
                  (click)="toggleOrigem('Origem: Ofertas VW')">
                  Ofertas VW
                </button>
                }

                @if (availableOrigins.includes('campanha')) {
                <button class="filter-pill-button" [class.selected]="isOrigemSelected('Origem: Campanha')"
                  (click)="toggleOrigem('Origem: Campanha')">
                  Campanha
                </button>
                }

                @if (availableOrigins.includes('S&D-PF')) {
                <button class="filter-pill-button" [class.selected]="isOrigemSelected('Origem: S&D PF')"
                  (click)="toggleOrigem('Origem: S&D PF')">
                  S&D PF
                </button>
                }

                @if (availableOrigins.includes('S&D-PJ')) {
                <button class="filter-pill-button" [class.selected]="isOrigemSelected('Origem: S&D PJ')"
                  (click)="toggleOrigem('Origem: S&D PJ')">
                  S&D PJ
                </button>
                }

                @if (availableOrigins.includes('S&D-CONCESSIONARIOS')) {
                <button class="filter-pill-button" [class.selected]="isOrigemSelected('Origem: S&D CONCESSIONARIOS')"
                  (click)="toggleOrigem('Origem: S&D CONCESSIONARIOS')">
                  S&D CONCESSIONARIOS
                </button>
                }

                @if (availableOrigins.includes('S&D-COBRANDED')) {
                <button class="filter-pill-button" [class.selected]="isOrigemSelected('Origem: S&D COBRANDED')"
                  (click)="toggleOrigem('Origem: S&D COBRANDED')">
                  S&D COBRANDED
                </button>
                }
              </div>
            </div>

            <!-- Seção Status Lead -->
            <div class="filter-section" *ngIf="isAvailableFilter('statusLead')">
              <label class="filter-section-label">Status:</label>
              <div class="filter-buttons-group">
                <button *ngFor="let status of statusLeadFilters" class="filter-pill-button"
                  [class.selected]="isStatusLeadIdFilterSelected(status.id)"
                  (click)="toggleStatusLeadIdFilter(status.id)">
                  {{ status.nome }}
                </button>
              </div>
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Filtro de data (disponível em ambos os modos) - Desktop -->
      <div class="filter-item desktop-date-view" *ngIf="!isMobile()">
        <button class="filter-button" [class.active]="startDate || endDate">
          <img src="assets/icons/data.png" alt="Data" class="filter-icon">
        </button>

        <div class="date-fields">
          <div class="custom-date-input">
            <input type="date" [(ngModel)]="startDate" (change)="onDateChange()" [max]="endDate || today"
              class="date-input-native" #startDateInput (click)="startDateInput.showPicker()">
            <div class="date-display" (click)="startDateInput.showPicker()">
              {{ getDisplayDate(startDate) || 'DD/MM/AAAA' }}
            </div>
            <img src="assets/icons/arrowDownCalendar.png" alt="Calendário" class="calendar-icon"
              (click)="startDateInput.showPicker()">
          </div>

          <div class="custom-date-input">
            <input type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
              class="date-input-native" #endDateInput (click)="endDateInput.showPicker()">
            <div class="date-display" (click)="endDateInput.showPicker()">
              {{ getDisplayDate(endDate) || 'DD/MM/AAAA' }}
            </div>
            <img src="assets/icons/arrowDownCalendar.png" alt="Calendário" class="calendar-icon"
              (click)="endDateInput.showPicker()">
          </div>
        </div>
      </div>

      <!-- Filtro de data - Mobile View -->
      <div class="filter-item mobile-date-view" *ngIf="isMobile()">
        <button class="mobile-date-button" (click)="openDatePickerModal()">
          <span class="mobile-date-text">
            {{ getDisplayDate(startDate) || 'DD/MM/AAAA' }}
            <span class="date-separator"> a </span>
            {{ getDisplayDate(endDate) || 'DD/MM/AAAA' }}
          </span>
          <img src="assets/icons/arrowDownCalendar.png" alt="Calendário" class="calendar-icon">
        </button>
      </div>

      <!-- Botão Limpar (disponível em ambos os modos) -->
      <button class="clear-button" (click)="clearAll()">
        Limpar
      </button>
    </div>
  </div>

  <!-- Modal de Filtro para Mobile -->
  <div class="filter-modal-mobile" *ngIf="isFilterModalOpen" [class.active]="isFilterModalOpen">
    <div class="modal-overlay" (click)="closeFilterModal()"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h3>Filtrar</h3>
        <button class="close-button" (click)="closeFilterModal()">✕</button>
      </div>

      <div class="modal-body">
        <!-- Seção Pré Aprovação -->
        <div class="filter-section" *ngIf="isAvailableFilter('preAprovado')">
          <label class="filter-section-label">Pré Aprovação:</label>
          <div class="filter-buttons-group">
            <button class="filter-pill-button"
              [class.selected]="isTempPreAprovacaoSelected('Pré Aprovação: Pré Aprovado')"
              (click)="toggleTempPreAprovacao('Pré Aprovação: Pré Aprovado')">
              Pré Aprovado
            </button>
            <button class="filter-pill-button"
              [class.selected]="isTempPreAprovacaoSelected('Pré Aprovação: Necessita Análise')"
              (click)="toggleTempPreAprovacao('Pré Aprovação: Necessita Análise')">
              Necessita Análise
            </button>
            <button class="filter-pill-button"
              [class.selected]="isTempPreAprovacaoSelected('Pré Aprovação: Não Solicitado')"
              (click)="toggleTempPreAprovacao('Pré Aprovação: Não Solicitado')">
              Não Solicitado
            </button>
          </div>
        </div>

        <!-- Seção Renova+ -->
        <div class="filter-section" *ngIf="isAvailableFilter('renovaMais')">
          <label class="filter-section-label">Renova+:</label>
          <div class="filter-buttons-group">
            <button class="filter-pill-button" [class.selected]="isTempRenovaSelected('Renova+: Sim')"
              (click)="toggleTempRenova('Renova+: Sim')">
              Sim
            </button>
            <button class="filter-pill-button" [class.selected]="isTempRenovaSelected('Renova+: Não')"
              (click)="toggleTempRenova('Renova+: Não')">
              Não
            </button>
          </div>
        </div>

        <!-- Seção Origem -->
        <div class="filter-section" *ngIf="isAvailableFilter('origem')">
          <label class="filter-section-label">Origem:</label>
          <div class="filter-buttons-group">
            <button class="filter-pill-button" [class.selected]="isTempOrigemSelected('Origem: Sempre Novo')"
              (click)="toggleTempOrigem('Origem: Sempre Novo')">
              Sempre Novo
            </button>
            <button class="filter-pill-button" [class.selected]="isTempOrigemSelected('Origem: Ofertas VW')"
              (click)="toggleTempOrigem('Origem: Ofertas VW')">
              Ofertas VW
            </button>
            <button class="filter-pill-button" [class.selected]="isTempOrigemSelected('Origem: Campanha')"
              (click)="toggleTempOrigem('Origem: Campanha')">
              Campanha
            </button>
          </div>
        </div>

        <!-- Seção Status Lead -->
        <div class="filter-section" *ngIf="isAvailableFilter('statusLead')">
          <label class="filter-section-label">Status:</label>
          <div class="filter-buttons-group">
            <button *ngFor="let status of statusLeadFilters" class="filter-pill-button"
              [class.selected]="isTempStatusLeadIdFilterSelected(status.id)"
              (click)="toggleTempStatusLeadIdFilter(status.id)">
              {{ status.nome }}
            </button>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="button-cancel" (click)="closeFilterModal()">Cancelar</button>
        <button class="button-confirm" (click)="confirmFilterSelection()">Confirmar</button>
      </div>
    </div>
  </div>

  <!-- Modal de Data para Mobile -->
  <div class="date-picker-modal" *ngIf="isDatePickerModalOpen" [class.active]="isDatePickerModalOpen">
    <div class="modal-overlay" (click)="closeDatePickerModal()"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h3>Selecionar Período</h3>
        <button class="close-button" (click)="closeDatePickerModal()">✕</button>
      </div>

      <div class="modal-body">
        <div class="modal-date-section">
          <label class="modal-label">Data Inicial</label>
          <div class="custom-date-input">
            <input type="date" [(ngModel)]="tempStartDate" [max]="tempEndDate || today" class="date-input-native"
              #modalStartDateInput (click)="modalStartDateInput.showPicker()">
            <div class="date-display" (click)="modalStartDateInput.showPicker()">
              {{ getDisplayDate(tempStartDate) || 'DD/MM/AAAA' }}
            </div>
            <img src="assets/icons/arrowDownCalendar.png" alt="Calendário" class="calendar-icon"
              (click)="modalStartDateInput.showPicker()">
          </div>
        </div>

        <div class="modal-date-section">
          <label class="modal-label">Data Final</label>
          <div class="custom-date-input">
            <input type="date" [(ngModel)]="tempEndDate" [min]="tempStartDate" [max]="today" class="date-input-native"
              #modalEndDateInput (click)="modalEndDateInput.showPicker()">
            <div class="date-display" (click)="modalEndDateInput.showPicker()">
              {{ getDisplayDate(tempEndDate) || 'DD/MM/AAAA' }}
            </div>
            <img src="assets/icons/arrowDownCalendar.png" alt="Calendário" class="calendar-icon"
              (click)="modalEndDateInput.showPicker()">
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="button-cancel" (click)="closeDatePickerModal()">Cancelar</button>
        <button class="button-confirm" (click)="confirmDateSelection()">Confirmar</button>
      </div>
    </div>
  </div>
</div>
